<div class="c-cms-form">
    <div class="form-flex">
        <div class="form-label">{{if field.required == 1}}<span class="form-required">*</span>{{/if}}{{field.displayName}}</div>
        <div class="form-value">
            {{each field.listOptions}}
            <div class="form-row">
                <div class="c-form-select {{$index > 0 ? 'u-mt8': ''}}">
                    <div class="select-menu">
                        <div class="select-value">{{field.value[$index] || '请选择'}}</div>
                        <div class="select-tips"></div>
                    </div>
                    <ul class="select-main">
                        {{each $value $data $cIndex}}
                        <li onclick="$sk.clickLIST('{{$data.optionId}}', '{{field.fieldName}}',{{$index}})" class="{{$data.checked ? 'active' : ''}}">
                            <span class="select-text">
                                {{$data.optionValue}}
                            </span>
                        </li>
                        {{/each}}
                    </ul>
                </div>
            </div>
            {{/each}}
            {{if field.dirty && field.invalid}}
            <div class="form-row form-error">{{field.validationMessage}}</div>
            {{/if}}
        </div>
    </div>
</div>